import ajax from './ajax';
import cache from './cache';
import OSS from 'ali-oss';

const api = {
  //公共模块
  public: {
    config: {
      accessKeyId: '',
      accessKeySecret: '',
      stsToken: '',
      expiration: '',
      endpoint: '',
      bucket: '',
    },
    oss: {
      path: {
        // 未知默认
        default: 'lmOpen/default/images/',
        //供货商图片
        lmOpenSupplier: 'lmOpen/supplier',
      },
      onceClient(param) {
        api.public.oss.getOssConfig(data => {
          new OSS.Wrapper({
            accessKeyId: data.accessKeyId,
            accessKeySecret: data.accessKeySecret,
            stsToken: data.stsToken,
            expiration: data.expiration,
            bucket: data.bucket,
            endpoint: data.endpoint
          }).multipartUpload(api.public.oss.getPath(param.type, param.suffix), param.file, {
            parallel: 2,
            progress: function* (percent, cpt) {
              typeof param.progress === 'function' && param.progress(percent, cpt);
            }
          }).then(function (result) {
            typeof param.success === 'function' && param.success(result);
          }).catch(function (err) {
            typeof param.error === 'function' && param.error(err);
          });
        });
      },
      getPath(type = 'default', suffix = 'jpg') {
        if (type.startsWith("tinyApp")) {
          let param = type.split("/")
          return api.public.oss.path[param[0]] + param[1] + "/" + suffix;
        } else {
          return api.public.oss.path[type] + new Date().getTime() + Math.random().toString(36).substr(2) + '.' + suffix;
        }
      },
      getOssConfig(fn) {
        if (!api.public.config.accessKeyId) {
          const ossConfig = cache.fetchOssConfig();
          if (ossConfig && ossConfig.accessKeyId) {
            fn({...ossConfig})
          } else {
            api.public.oss.initOssConfig(fn);
          }
        } else {
          fn({...api.public.config})
        }
      },
      initOssConfig(fn) {
        ajax.fetch({
          url: 'supplier/getOssConfig',
          disableLoading: false,
          method: 'get',
          successFunc: response => {
            api.public.config.accessKeyId = response.access_key_id;
            api.public.config.accessKeySecret = response.access_key_secret;
            api.public.config.stsToken = response.security_token;
            api.public.config.expiration = response.expiration;
            api.public.config.endpoint = response.endPoint;
            api.public.config.bucket = response.bucket;
            cache.storeOssConfig(response);
            typeof fn === 'function' && fn({...api.public.config});
          },
          errorFunc: error => {
            console.log(error)
          }
        })
      },
    },

    getConfigFn() {
      ajax.fetch({
        url: api.public.getConfig,
        method: 'get',
        noConfigCheck: true,
        successFunc: data => {
          api.public.oss.path = data.ossUrl;
        },
        errorFunc: error => {
          // alert('获取oss配置失败，请刷新浏览器，若不使用上传文件功能可忽略');
        }
      })
    },
    getConfig: "login/getConfig"

  },
//登录
  login: {
    loginAut: 'login/loginAuth',// 登录接口供货商
    getVerifyCode: 'login/getVerifyCode',// 发送短信
    loginOut: 'login/loginOut',// 登出
    submitTradeLogin: 'trade/submitTradeLogin',// 供货商注册
    deposit: 'trade/deposit',// 供货商缴纳保证金
    selectUser: 'trade/selectUser',// 供货商查询接口
    submitLegerRegister:'ledger/legerRegister',//注册分账系统
    getElementToken:'ledger/getElementToken',
    submitLegerActivate:'ledger/legerActivate',
    submitLegerVerify:'ledger/legerVerify'
  },
//库存管理
  inventoryManagement: {

    getCommodityList: "trade/commodityList",//供应商查询所有商品
    getLinkage: "trade/linkage",//供货商查询授权规格
    getLinkageAll: "trade/linkageAll",//供货商查询所有成本
    updateModifyPrice: "trade/updateModifyPrice",//供应商修改成本
    maxMin: "trade/maxMin",//修改成本时的最小成本查询
    exportProductStock: "trade/exportProductStock",//提取库存
    viewInventory: "trade/viewInventory",//查看库存
    updateInventory: "trade/information",//删除单个库存
    addInventory: "trade/addInventory",//新增cdk卡密
    addInventoryS: "trade/addInventoryS",//新增cdk激活码
    addStock: "trade/addStock",//添加库存卡密
    addStockS: "trade/addStockS",//添加库存激活码
    selectRate: "supplier/selectRate",//费率接口
    selectKey: "trade/selectKey",//供货商查询key
    supplySequence: "trade/supplySequence",//供货序列
    exportProductStockAll: "trade/exportProductStockAll",//导出明细
    updateInventoryHideStatus: "trade/updateInventoryHideStatus",//更新隐藏状态

  },
//账号信息
  personalCenter: {
    information: "login/information",//供货商账号信息
    updateInformation: "login/updateInformation",//更改账号信息
    nickName: "supplier/nickName",//供货商注册时查询昵称是否存在

  },
  //我的订单
  myOrder: {
    getOrderList: "tradeOrder/orderList",//供货商查询订单
    orderDetails: "tradeOrder/orderDetails",//供货商查询完成订单的详情
    orderStock: "tradeOrder/orderStock",//供货商订单导出
  },
  //我的提现
  myWithdrawal: {
    getCashList: "cash/cashList",//我的提现
    recordEmbodiment: "cash/recordEmbodiment",//生成提现订单
    balancePay: "cash/balancePay",//生成提现订单 (id为6时用)
    balancePayVerify: "cash/balancePayVerify",//余额支付验证 (id为6时用)
    bond: "cash/bond",//供货商退保证金
    recordEmbodiment2c:'cash/recordEmbodiment2c',
    recordEmbodimentVerify:'cash/recordEmbodimentVerify',
    resetPwd:'cash/findPasswordApply', // 供货商提现密码重置密码申请
    changPassword:'cash/findPasswordVerify',// 修改密码
    legerChangeCardApply: 'ledger/legerChangeCardApply', // 换绑卡申请
    legerChangeCardVerify: 'ledger/legerChangeCardVerify', // 换绑卡验证
    modifyUserInfo: 'ledger/modifyUserInfo',// 商户个人用户信息修改
    uploadIdFile: 'ledger/uploadIdFile',// 商户上传身份证照片
  },
};
export default api;



// WEBPACK FOOTER //
// ./src/utility/api.js